/**
 * authFetch — universal authenticated fetch utility
 *
 * Attaches Authorization: Bearer token from localStorage to all API calls.
 * Uses Bearer tokens exclusively — no credentials/cookies needed.
 * Dispatches 'fs_subscription_required' custom event on 403 subscription gates.
 */

const TOKEN_KEY = 'fs_session_token';

export const getStoredToken = () => {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
};

export const setStoredToken = (token) => {
  try { if (token) localStorage.setItem(TOKEN_KEY, token); } catch { /* ignore */ }
};

export const clearStoredToken = () => {
  try { localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ }
};

export const authFetch = (url, options = {}) => {
  const token = getStoredToken();
  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  return fetch(url, { ...options, headers }).then(response => {
    if (response.status === 403) {
      response.clone().json().then(data => {
        if (data?.detail?.code === 'subscription_required') {
          window.dispatchEvent(new CustomEvent('fs_subscription_required', {
            detail: {
              required_plan: data.detail.required_plan,
              current_plan: data.detail.current_plan,
              expired: data.detail.expired,
              message: data.detail.message,
            },
          }));
        }
      }).catch(() => {});
    }
    return response;
  });
};
